<script setup lang="ts">
import { useSessionPanelsStore } from '@/stores/session-panels.ts';
import { PBadge, PSidePanelTrigger } from '@pokerly/ui';
import { useRoundsStore } from '@/stores/rounds-store.ts';
import { computed } from 'vue';

const sessionPanelsStore = useSessionPanelsStore();
const roundsStore = useRoundsStore();
const totalRounds = computed(() => roundsStore.rounds.length);
</script>

<template>
    <div class="flex items-center">
        <PSidePanelTrigger
            :is-open="sessionPanelsStore.roundsPanel"
            @click="sessionPanelsStore.toggleRoundsPanel"
            side="right"
        />
        <div :data-side-panel-open="sessionPanelsStore.roundsPanel" class="data-[side-panel-open=true]:w-0">
            <div class="min-w-max flex p-2 items-center gap-2">
                <span class="font-bold text-sm">Round</span>
                <span class="font-bold text-sm">{{ totalRounds }}/{{ totalRounds }}</span>
                <PBadge variant="secondary">100%</PBadge>
            </div>
        </div>
    </div>
</template>
